import { TreeemapNode } from 'app/components/Charts/treemap/common/node';
import { TreemapTooltip } from 'app/components/Charts/treemap/common/tooltip';

interface TreeemapNodeChildData {
  title: string;
  size: number;
}

interface TreeemapNodeData {
  name: string;
  color: string;
  value: number;
  orgs?: TreeemapNodeChildData[];
}

export interface TreemapDataModel {
  name: string;
  color: string;
  children: TreeemapNodeData[];
}

export interface TreemapProps {
  label: string;
  data: TreemapDataModel;
  pageParam: string;
  detailBaseFilter: string;
}

const TreemapVizColors = [
  '#BEE5E0',
  '#cbeae6',
  '#d8efec',
  '#e5f5f3',
  '#f2faf9',
  '#f9fcfc',
];

export const TreemapVizModel = {
  label: 'name',
  animate: true,
  value: 'value',
  tile: 'squarify',
  leavesOnly: true,
  identity: 'name',
  motionDamping: 11,
  orientLabel: false,
  motionStiffness: 90,
  labelTextColor: '#2E4063',
  tooltip: TreemapTooltip,
  nodeComponent: TreeemapNode,
  colors: (node: any) => node.color,
  theme: {
    tooltip: {
      container: {
        borderRadius: 20,
        padding: '16px 25px',
      },
    },
  },
};

export const emptyData = {
  name: 'empty',
  color: '',
  children: [
    {
      color: '#EBEBEB',
      name: 'CA-3',
      orgs: [],
      ref: 'CA-3',
      value: 3,
    },
    {
      color: '#EBEBEB',
      name: 'CA-2',
      orgs: [],
      ref: 'CA-2',
      value: 2,
    },
    {
      color: '#EBEBEB',
      name: 'CA-1',
      orgs: [],
      ref: 'CA-1',
      value: 1,
    },
    {
      color: '#EBEBEB',
      name: 'CA-0',
      orgs: [],
      ref: 'CA-0',
      value: 0.5,
    },
  ],
};
